/**
 * Shared utility for clearing localStorage and sessionStorage keys on logout.
 * All logout handlers should use this function to ensure consistency.
 *
 * IMPORTANT: Do NOT add these keys here (app-level, not user-specific):
 *   - _zenvoya_airPorts, arrival, departure → Public airport data, heavy API re-fetch
 *   - _trip_trove_app_config → App feature flags, same for all users
 *   - _zenvoya_access_JWT → App-level token, logout flow already refreshes it via getAccessToken()
 *   - _TEST → Socket streaming flag, not user-specific
 */

export function logoutClearStorage() {
  const keysToRemove = [
    // Auth
    "_zenvoya_JWT",
    // Trip/Itinerary
    "_starting",
    "_destination",
    "_extra_meta",
    "_international",
    "_select_dest_flag",
    "shared_itinerary_id",
    "_itinerary_details_from_list",
    "_itinerary_details",
    "_shared_itinerary_id",
    "_sliderValue",
    // Chat / panel UI state — leaks stale selection (purple cards) into next login session
    "_trip_trove_selected_chat_data",
    "_trip_trove_chat_data",
    "screen_details",
    "first_screen_details",
    // Booking wizard position — a stale review/traveller/payment crumb restored
    // after re-login re-mounts a blank, exit-less review (working state + backend
    // prebook are gone). Boot-time sanitizeStaleBookingSession() also guards this,
    // but clearing on explicit logout keeps the two tiers in sync.
    "_zenvoya_active_breadcrumbs",
    "_zenvoya_breadcrumbs_list",
    // UTM/Analytics
    "utmParams",
    "utm_source",
    // Onboarding/Traveler
    "temp_onboarding_travelWith",
    "hasSeenTravelerDialog",
    "trip_travelers",
    "activity_booking_flow_state",
    "activity_review_state",
    "activity_search",
    "activity_search_params",
    "activity_cart_items",
    "_zenvoya_initial_loading_seen",
    "_zenvoya_open_tabs",
    "_zenvoya_loading_seen_this_tab",
    "_zenvoya_saved_itinerary_hero",
    // Pre-login Theresias event buffer — drop on logout so the next user's
    // onboarding events don't replay under their userId. See
    // src/services/intent/pendingTheresiasQueue.ts.
    "_zenvoya_pending_theresias_v1",
  ];

  keysToRemove.forEach((key) => {
    window.localStorage.removeItem(key);
    window.sessionStorage.removeItem(key);
  });
}
